export const INITIATE_DATA = {
    share_uid: "",
    action_type: "send_email",
    sender_email: "",
    receiver_email: "",
    email_subject: "",
    email_body: "",
}

export const EMAIL_VALIDATE = {
    emailTo: false,
    yourEmail: false,
    subjectLine: false,
    messageContent: false,
}

export const MAX_TOTAL_SIZE = 2 * 1024 * 1024 * 1024; // 2 Go en bytes

export const CHUNK_SIZE = 500 * 1024; // 500 Ko

export const INIT_DATA_AUTH = {
  access_token: "",
  refresh_token: "",
  auth: {
    uid: "",
    email: ""
  }
}

export const INIT_WORKSPACE_DATE = {
  uid: "",
  name: "",
  size: 0,
  expires_at: "",
  sender_email: "",
  receiver_email: "",
  created_at: "",
  updated_at: "",
  share_token: ""
}

